import * as React from 'react';
const PlayIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.493 4.096a.156.156 0 0 0-.243.13v11.548c0 .125.14.199.243.13l8.66-5.774a.156.156 0 0 0 0-.26zm-1.243.13c0-.923 1.03-1.474 1.798-.962l8.66 5.774a1.156 1.156 0 0 1 0 1.924l-8.66 5.774a1.156 1.156 0 0 1-1.798-.962z"
      fill="currentColor"
    />
  </svg>
);
export default PlayIcon;
